import { useBottomSheet } from "../context/BottomSheetContext";
import UpgradeResultModalContent from "../components/upgradeResultModalContent";
import { useUserContext } from "../context/UserContext";

export const useUpgradeResultModal = () => {
  const { openSheet,closeSheet } = useBottomSheet();
  const {fetchUser} = useUserContext();

  const openUpgradeResultModal = (cryptid, result,titleX) => {
    openSheet({content:<UpgradeResultModalContent closeSheet={closeUpgradeResultModal} cryptid={cryptid} result={result} />,title:titleX ? titleX : result  ? "Successful" : "Unsuccessful"})
 }
const closeUpgradeResultModal = () => {
  setTimeout(() => {
    fetchUser();
  }, 1000);
  closeSheet();
}


  return { openUpgradeResultModal ,closeUpgradeResultModal};
}
